
import {Component, Vue} from 'vue-property-decorator'
import {UserModule} from '@/store/module/user'
import {getPriceList, getTaskList, submitFeedback} from '@/api/home'
import {getContentList, getNoticeContent} from '@/api/content'
import {CommonModule} from '@/store/module/common'
import {getCurrentUserBill} from "@/api/manager";
import TaskStatus from '@/views/home/components/taskStatus.vue'
import {eventBus} from "@/main";

@Component({
	name: 'TopBar',
	components: {
		TaskStatus
	}
})
export default class TopBar extends Vue {
	// TODO: 需要修改下拉菜单选项及对应功能
	userName = 'admin'
	dropdownList = [
		{
			name: '退出'
		}
	]
	banlance: any = {}
	// 平台价格
	iconList = [
		'活动专区',
		'盲盒专区',
		'Mobile Check',
		'Line',
		'WhatsApp',
		'Telegram',
		'Zalo',
		'Signal',
		'Skype',
		'Facebook',
		'Instagram',
		'Binance',
		'Linkedin',
		'Microsoft',
		'Twitter',
		'Amazon',
		'Viber',
		'成品代筛',
		'SnapChat',
		'kakaotalk',
		'Wish',
		'MoMo',
		'botim',
		'okx',
		'htx',
		'bybit',
		'mint',
		'gate',
		'platform-manage',
		'platform',
		'tiktok',
		'rcs',
		'flipkart',
		'hh',
		'band',
		'cian',
		'moj',
		'paytm',
		'teams',
		'mail'
	]
	idList = [
		'active_',
		'blind',
		'phone',
		'line',
		'ws',
		'tg',
		'zalo',
		'signal',
		'skype',
		'fb',
		'ins',
		'binance',
		'linkedin',
		'ms',
		'twitter',
		'amazon',
		'viber',
		'agent',
		'snapchat',
		'kakao',
		'wish',
		'momo',
		'botim',
		'okx',
		'htx',
		'bybit',
		'mint',
		'gate',
		'event',
		'black',
		'tiktok',
		'rcs',
		'flipkart',
		'hh',
		'band',
		'cian',
		'moj',
		'paytm',
		'teams',
		'mail'
	]
	listData: any[] = []
	priceData: any[] = []
	// 公告
	noticeList: any[] = []
	noticeData: any = {}
	noticeDialogVisible = false
	dialogVisible = false
	Contacts = ''
	Content = ''
	helpDialog = false

	get userInfo() {
		return UserModule?.userInfo
	}

	created() {
		UserModule.getUserInfo().then(() => {
			CommonModule.HANDLE_INIT_MENU(true)
		})
	}

	mounted() {
		this.initNoticeList()
		this.initPriceList()

	}

	clickIcon(code: any, subItem: any) {
		eventBus.$emit('clickPriceTask', code, subItem);
	}

	handleDropdownCommand(dropdownItem: any) {
		switch (dropdownItem.name) {
			case '退出':
				UserModule.logout()
				break
			default:
				break
		}
	}

	initPriceList() {
		getTaskList()
			.then(res => {
				this.listData = []
				res.data.forEach((item: any) => {
					const index = this.idList.indexOf(item.Platform)
					this.listData.push({
						...item,
						path: this.iconList[index] && require(`@/assets/img/${this.iconList[index]}.png`)
					})
					this.listData.sort((a, b) => b.Runnings - a.Runnings)
				})
			})
			.catch(err => {
				console.log(err)
				this.$message.error(err.msg)
			})

		getPriceList()
			.then(res => {
				this.priceData = []
				res.data.forEach((item: any) => {
					const index = this.idList.indexOf(item.Platform)
					this.priceData.push({
						...item,
						status: item.CanOrder === 1 ? '正常' : '升级中',
						icon: this.iconList[index] && require(`@/assets/img/${this.iconList[index]}.png`)
					})
				})
				console.log(this.priceData)
			})
			.catch(err => {
				console.log(err)
				this.$message.error(err.msg)
			})

		getCurrentUserBill()
			.then(res => {
				this.banlance = res.data
			})
			.catch(err => {
				this.$message.error(err.msg)
			})
	}

	initNoticeList() {
		const params = {
			classCode: 'notice',
			pageNum: 1,
			limit: 10
		}
		getContentList(params).then(res => {
			this.noticeList = res.data
		})
	}

	handleShowNotice(item) {

		const id = item.ID
		getNoticeContent({id})
			.then(res => {
				this.noticeData.Content = res.data.Content
				this.noticeData.Title = res.data.Title
				this.noticeDialogVisible = true
			})
			.catch(err => {
				this.$message.error(err.msg)
			})
	}

	handleDrump() {
		// window.open('/article/help')
		window.open(`${process.env.VUE_APP_BASE_URL}/article/help`)
	}

	handleShowMessage() {
		// 点击打开留言弹框
		this.Contacts = ''
		this.Content = ''
		this.dialogVisible = true
	}

	handleShowHelp() {
		this.helpDialog = true
	}

	handleConfirm() {
		// 点击确定提交留言
		const data = {
			Contacts: this.Contacts,
			Content: this.Content
		}
		if (!this.Contacts) {
			this.$message.warning('请输入联系方式')
		} else if (!this.Content) {
			this.$message.warning('请输入反馈内容')
		} else {
			submitFeedback(data)
				.then(() => {
					this.$message.success('反馈成功')
					this.Contacts = ''
					this.Content = ''
				})
				.catch(err => {
					this.$message.error(err.msg)
				})
		}
	}

	handleClickBill() {
		this.$emit('clickBill')
	}

	clickLogo() {
		this.$emit('clickLogo')
	}
}
